import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoWallPost } from "@/shared/model/edo-wall-post.model";
import { deleteEntity } from "@/shared/reducers/entities/edo-wall-post.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { Translate } from "react-jhipster";

interface IDeleteWallPostProps {
    post: IEdoWallPost;
    open: boolean;
    onClose: () => void;
}

const DeleteWallPostDialog = (props: IDeleteWallPostProps) => {
    const dispatch = useAppDispatch();
    const { updateSuccess } = useAppSelector<EntityState<IEdoWallPost>>((state) => state.edoWallPost);

    const { open, onClose: handleClose, post } = props;

    const confirmDelete = () => {
        dispatch(deleteEntity(post.id));
    };

    useEffect(() => {
        if (updateSuccess) {
            handleClose();
        }
    }, [updateSuccess]);

    return (
        <Dialog open={open} onOpenChange={(open) => !open && handleClose()}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        <Translate contentKey="entity.delete.title" />
                    </DialogTitle>
                </DialogHeader>
                {!post ? (
                    <div className="flex justify-center py-4">
                        <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
                    </div>
                ) : (
                    <DialogDescription>
                        <Translate contentKey="edocendoApp.edoWallPost.delete.question" />
                    </DialogDescription>
                )}
                <DialogFooter>
                    <Button variant="outline" onClick={handleClose}>
                        <Translate contentKey="entity.action.cancel" />
                    </Button>
                    <Button onClick={confirmDelete} variant="default">
                        <Translate contentKey="entity.action.delete" />
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteWallPostDialog;